<template>
<div>
  <b-container fluid style="height: 85vh;xmargin-top:15%">
    <b-row no-gutters class="row h-100">
      <b-col cols="12" align="center" style="display: flex; flex-direction: column; justify-content: center; align-items: center">
        <div class="subTitle" style="margin-bottom: 2rem">Welcome back to Moogenda!  <br>Sign in with Google to access your account.</div>
        <b-btn variant="link" @click="$emit('login')"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn>
        <b-alert :show="showAccountMessage" variant="light"><b>We're not able to find your Moogenda account.  Please contact <a href="mailto:support@moogenda.com">support@moogenda.com</a></b></b-alert>
        <!-- <div class="terms">By registering for early access you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div> -->
        <br><br><br>
      </b-col>
    </b-row>
  </b-container>
  </div>
</template>
<script>
// import {firebase, db, router} from '../main'
import {firebase, router} from '../main'
export default {
  name: 'Login',
  data () {
    return {
      showAccountMessage: false
    }
  },
  methods: {
//     loginGoogle () {
//       console.log('1. start login')
//       var provider = new firebase.auth.GoogleAuthProvider()
//       firebase.auth().signInWithPopup(provider).then((result) => {
//         router.replace({name: 'MyMeetings'})
//
//         /* Code to check if user has an account - Only used for closed Beta.
//            Uncommen the code below to reinstate the functionality.
//            Also need to update the firestore rule signedIn() function to check if the user has an account document.
//             function signedIn () {
// return request.auth.uid != null && exists(/databases/$(database)/documents/Accounts/$(request.auth.token.email))
//               }
//
//           var user = result.user
//           var docRef = db.collection('Accounts').doc(user.email)
//           docRef.get().then((accountDoc) => {
//             if (accountDoc.exists) {
//               router.replace({name: 'MyMeetings'})
//             }
//           }).catch((firebaseError) => {
//             firebase.auth().signOut().then(() => {
//               this.showAccountMessage = true
//               console.log(firebaseError)
//             })
//           })
//        */
//       }).catch(function (error) {
//         console.log('5.1 Error')
//         console.log(error)
//       })
//     }
  },
  mounted: function () {
    console.log('signin=' + this.$route.query.signin)
  }
}
</script>
<style scoped>
  .subTitle{font-size:1.6rem;color:#262626;text-align: left;margin-top:1.1rem}
    .bigTitle{font-size:3.4rem;font-family: Source Sans Pro;color:#262626;line-height: 3.6rem;text-align: left;font-weight:600;Xmax-width: 22rem;margin:.5rem 0;margin-Top:1rem;letter-spacing: 0.rem;text-align: center}
  .accountMessage{font-weight: bold}
</style>
